const countdown = {
  countdownWrap: document.querySelectorAll(".jsContdown") as NodeListOf<HTMLElement>,
  current: new Date() as Date,
  date: new Date() as Date,
  month: 6,
  day: 1,

  init() {
    if (this.countdownWrap && this.isCurrentDate()) {
      this.setDate()
      this.countTimer()
    }

  },
  setDate() {
    const currentYear = this.current.getFullYear()
    this.date.setFullYear(currentYear, this.month, this.day)
    this.date.setHours(1, 0, 0)
  },
  isCurrentDate() {
    return this.current.getFullYear() === this.date.getFullYear() && this.current.getMonth() === this.date.getMonth() && this.current.getDate() === this.date.getDate()
  },
  getValues() {
    const current = new Date()
    const date = this.date.getTime()
    const timeleft = date - current.getTime()  
    return {
      days: Math.floor(timeleft / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeleft % (1000 * 60)) / 1000),
      left: timeleft,
    }
  },
  countTimer() {
    let interval = setInterval(() => {
      const date = this.getValues()
      this.changeHtml(this.counterHtml(date.days, date.hours, date.minutes, date.seconds))
      if (date.left < 0) {
        clearInterval(interval)
        this.changeHtml(this.counterHtml(0, 0, 0, 0))
      }
    }, 1000)
  },
  changeHtml(html: string){
    this.countdownWrap.forEach(item=>{
      item.innerHTML = html
    })
  },
  counterHtml(day: number, hour: number, min: number, sec: number) {
    return ` <div class="home-countdown__content-item">
                    <span>${day}</span>
                    <span>DAYS</span>
                </div>
                <div class="home-countdown__content-item">
                    <span>${hour}</span>
                    <span>HOURS</span>
                </div>
                <div class="home-countdown__content-item">
                    <span>${min}</span>
                    <span>MIN</span>
                </div>         
                <div class="home-countdown__content-item">
                    <span>${sec}</span>
                    <span>SEC</span>
                </div>
        `
  },
}

export default countdown
